function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React, { Component } from 'react';
import { isFunction } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import filterChildren from "../../../utils/Children/filterChildren";
var TableRow = /*#__PURE__*/function (_Component) {
  function TableRow(props) {
    var _this;
    _classCallCheck(this, TableRow);
    _this = _callSuper(this, TableRow, [props]);
    _this.onCellClick = _this.onCellClick.bind(_this);
    return _this;
  }
  _inherits(TableRow, _Component);
  return _createClass(TableRow, [{
    key: "onCellClick",
    value: function onCellClick(columnIndex, event) {
      var parent = this.props.parent;
      if (parent === 'table-body' && isFunction(this.props.onCellClick)) {
        this.props.onCellClick(this.props.rowIndex, columnIndex, event);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        className = _this$props.className,
        id = _this$props.id,
        clickable = _this$props.clickable,
        children = _this$props.children,
        secondaryDataList = _this$props.secondaryDataList,
        style = _this$props.style,
        hoverable = _this$props.hoverable,
        dataTestId = _this$props.dataTestId;
      var tableRowClass = function tableRowClass() {
        return classNames({
          'ui-table-row': true,
          'ui-table-row--clickable': clickable,
          'ui-table-row--hoverable': hoverable
        }, className);
      };
      var filteredChildren = filterChildren(children);
      var childrenWithFuncs = React.Children.map(filteredChildren, function (child, index) {
        return /*#__PURE__*/React.cloneElement(child, {
          onCellClick: _this2.onCellClick,
          onKeyPress: _this2.onKeyPress,
          columnIndex: index,
          secondaryDataList: secondaryDataList
        });
      });
      var role = this.onCellClick !== null ? 'button' : 'row';
      var _onKeyPress = function onKeyPress(event) {
        event.preventDefault();
        if (clickable && (event.keyCode === 13 || event.keyCode === 32)) {
          _this2.props.onCellClick(_this2.props.rowIndex, null, event);
        }
      };
      return /*#__PURE__*/React.createElement("tr", {
        id: id,
        className: tableRowClass(),
        onClick: this.onCellClick,
        onKeyPress: function onKeyPress(e) {
          return _onKeyPress(e);
        },
        style: style,
        role: role,
        tabIndex: 0,
        "data-testid": dataTestId
      }, childrenWithFuncs);
    }
  }]);
}(Component);
TableRow.propTypes = {
  /** id for reference */
  id: PropTypes.string,
  /** className for reference */
  className: PropTypes.string,
  /** If true, row will be clickable */
  clickable: PropTypes.bool,
  /** If true, row will be hoverable */
  hoverable: PropTypes.bool,
  /** Override the inline-styles of the root element || Not Recommended */
  style: PropTypes.object,
  /**
   * children props for content inside
   * @ignore
   */
  children: PropTypes.node,
  /**
   * on cell click passed from the TableBody component
   * @ignore
   */
  onCellClick: PropTypes.func,
  /**
   * Row index passed from TableBody component
   * @ignore
   */
  rowIndex: PropTypes.number.isRequired,
  /**
   * Root parent component
   * @ignore
   */
  parent: PropTypes.string,
  /**
   * Data (in columns) to hide passed from TableHead or TableBody component
   * @ignore
   */
  secondaryDataList: PropTypes.array,
  /** Immutable identifier for testing */
  dataTestId: PropTypes.string
};
TableRow.defaultProps = {
  id: '',
  className: '',
  children: [],
  clickable: true,
  hoverable: true,
  onCellClick: null,
  rowIndex: 0,
  parent: '',
  secondaryDataList: [],
  style: {},
  dataTestId: ''
};
export default TableRow;